export default "__VITE_ASSET__CQ2kC8eS__"